<template lang="html">
  <span @click="click">
    <i class="el-icon-takeaway-box"></i> {{topicTitle}}
  </span>
</template>

<script>

  export default {
    components: {
    },
    props: {
      topicId: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        topicTitle: ''
      };
    },
    watch: {
    },
    computed: {
    },
    methods: {
      click: function (e) {
        window.console.log("CLICK@@@", e)
      }
    },
    mounted () {
      this.$api.topic.detail(this.topicId)
      .then(res => {
        this.topicTitle = res.data.title
      })      
    },
    destroyed () {
    }
  }
</script>

<style lang="css" scoped>

</style>
